import React from 'react';
import { alpha, Button, Typography } from '@mui/material';

import { ArrowDropUpIcon, ArrowDropDownIcon } from '@occc-app/design-system';

export type DateRangeSelectorButtonProps = {
  children?: React.ReactNode;
  open: boolean;
  handleOpen: React.MouseEventHandler<HTMLElement>;
  disabled?: boolean;
};

export const DateRangeSelectorButton = ({
  open,
  handleOpen,
  children,
  disabled = false,
}: DateRangeSelectorButtonProps) => {
  return (
    <Button
      variant='outlined'
      size='large'
      endIcon={
        open ? (
          <ArrowDropUpIcon color={disabled ? 'disabled' : 'primary'} />
        ) : (
          <ArrowDropDownIcon color={disabled ? 'disabled' : 'primary'} />
        )
      }
      onClick={handleOpen}
      disabled={disabled}
      sx={(theme) => ({
        ml: 'auto',
        bgcolor: theme.palette.background.paper,
        borderRadius: 1,
        borderColor: alpha(theme.palette.divider, 0.5),
        color: theme.palette.text.primary,
        paddingLeft: 2,
        paddingRight: 1.5,
        '&:hover': {
          bgcolor: theme.palette.background.paper,
          borderColor: () => theme.palette.divider,
          color: () => alpha(theme.palette.text.primary, 0.5),
        },
      })}
    >
      <Typography variant='subtitle2' textTransform='capitalize' letterSpacing={0}>
        {children}
      </Typography>
    </Button>
  );
};
